import { MessageDto } from "./MessageList";
import { HumanMessage, SystemMessage } from "@langchain/core/messages";

function mapMessagesToLangchain(messages: MessageDto[]) {
  return messages.map(message => {
      if (message.who === 'system') {
          return new SystemMessage(message.text);
      } else {
          return new HumanMessage(message.text);
      }
  });
}

export async function aiChat(messages: MessageDto[], selectedObjectId: string | null = null): Promise<string> {
  const langchainMessages = mapMessagesToLangchain(messages);

  const response = await fetch('/api/aiChat', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      messages: langchainMessages,
      selectedObjectId: selectedObjectId
    })
  });
  if (!response.ok) {
    throw new Error('Failed to fetch AI chat response from backend');
  }
  const data = await response.json();
  return data.result || 'No response received';
}